import React from 'react'

import { PlaylistButton } from 'src/Components/Buttons/PlaylistButton'

import { ReviewPlaylist } from '../ReviewBlock'

export const AddedPlaylistInfo: React.FC<ReviewPlaylist> = ({
  playlistName,
  playlistUrl,
  playlistCoverUrl,
}) => (
  <PlaylistButton
    playlistName={playlistName}
    playlistUrl={playlistUrl}
    playlistCoverUrl={playlistCoverUrl}
  />
)
